var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoicesIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 0.20874C11.47 0.20874 0.0833359 11.4087 0.0833359 25.2087C0.0833359 39.0087 11.47 50.2087 25.5 50.2087C39.53 50.2087 50.9167 39.0087 50.9167 25.2087C50.9167 11.4087 39.53 0.20874 25.5 0.20874ZM25.5 45.2087C14.2913 45.2087 5.16667 36.2337 5.16667 25.2087C5.16667 14.1837 14.2913 5.20874 25.5 5.20874C36.7088 5.20874 45.8333 14.1837 45.8333 25.2087C45.8333 36.2337 36.7088 45.2087 25.5 45.2087ZM27.7621 22.9587C23.2379 21.4837 21.0521 20.5587 21.0521 18.2087C21.0521 15.6587 23.8733 14.7337 25.6525 14.7337C28.9821 14.7337 30.2021 17.2087 30.4817 18.0837L34.4975 16.4087C34.1163 15.3087 32.4133 11.6337 27.7367 10.8337V7.70874H23.2888V10.8587C16.6804 12.2587 16.6296 17.9837 16.6296 18.2587C16.6296 23.9337 22.3483 25.5337 25.1442 26.5337C29.16 27.9337 30.9392 29.2087 30.9392 31.6087C30.9392 34.4337 28.2704 35.6337 25.9067 35.6337C21.2808 35.6337 19.9592 30.9587 19.8067 30.4087L15.5875 32.0837C17.1888 37.5587 21.3825 39.0337 23.2633 39.4837V42.7087H27.7113V39.6087C29.0329 39.3837 35.3871 38.1337 35.3871 31.5587C35.4125 28.0837 33.8621 25.0337 27.7621 22.9587Z",
    fill: "#1B2E6B",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoicesIcon3);
export default __webpack_public_path__ + "static/media/invoices-icon3.8de09d1803ebe039302ac5a47aedaf7e.svg";
export { ForwardRef as ReactComponent };